import React, { useState, useEffect } from 'react';
import api from '../../services/api';

const CategoryManager = () => {
  const [cats, setCats] = useState([]);
  const [editId, setEditId] = useState(null);
  const [editName, setEditName] = useState('');
  const [newName, setNewName] = useState('');
  const [merge, setMerge] = useState([]);

  const load = async () => {
    const expenseCats = await api.getAccountingCategories({ type: 'expense', includeInactive: true });

    const taxesExists = expenseCats.some(c => c.name === 'Taxes and Licenses' || c.name === 'Taxes & Licenses');

    if (!taxesExists) {
      try {
        await api.createAccountingCategory({ name: 'Taxes and Licenses', categoryType: 'expense' });
        const newData = await api.getAccountingCategories({ type: 'expense', includeInactive: true });
        setCats(newData);
      } catch (error) {
        console.error("Failed to create 'Taxes and Licenses' category:", error);
        setCats(expenseCats); // Use initially fetched data on error
      }
    } else {
      setCats(expenseCats);
    }
  };
  useEffect(() => { load(); }, []);

  const save = async () => { await api.updateAccountingCategory(editId, { name: editName }); load(); setEditId(null); };
  const deact = async (id) => {
    if (!confirm('Deactivate?')) return;
    try {
      await api.deleteAccountingCategory(id);
      load();
    } catch (e) {
      alert(e.message || 'Failed to deactivate category');
    }
  };
  const react = async (id) => { await api.updateAccountingCategory(id, { active: true }); load(); };
  const add = async () => { if(newName) { await api.createAccountingCategory({ name: newName, categoryType: 'expense' }); setNewName(''); load(); }};
  const doMerge = async () => { if(merge.length===2 && confirm('Merge?')) { await api.mergeCategories(merge[0], merge[1]); setMerge([]); load(); }};
  const tog = (id) => setMerge(p => p.includes(id) ? p.filter(x=>x!==id) : p.length>=2 ? [p[1],id] : [...p,id]);

  return (
    <div className="space-y-3">
      <div className="flex justify-between items-center">
        <b>Categories</b>
        {merge.length===2 && <button onClick={doMerge} className="text-sm bg-purple-600 text-white px-2 py-1 rounded">Merge Selected</button>}
      </div>
      <p className="text-xs text-gray-500">Click 2 categories to merge. Edit/Deactivate with buttons.</p>
      {cats.map(c => (
        <div key={c.id} onClick={()=>tog(c.id)} className={`flex justify-between p-2 rounded cursor-pointer ${merge[0]===c.id?'bg-red-100':merge[1]===c.id?'bg-green-100':'bg-gray-50'} ${c.active===false?'opacity-50':''}`}>
          {editId===c.id ? (
            <div className="flex gap-1 flex-1" onClick={e=>e.stopPropagation()}>
              <input value={editName} onChange={e=>setEditName(e.target.value)} className="flex-1 px-2 border rounded text-sm"/>
              <button onClick={save} className="text-xs bg-green-600 text-white px-2 rounded">Save</button>
              <button onClick={()=>setEditId(null)} className="text-xs px-2">X</button>
            </div>
          ) : (
            <>
              <span>{c.name}{c.active===false?' (off)':''}</span>
              <div className="flex gap-2 text-xs" onClick={e=>e.stopPropagation()}>
                <button onClick={()=>{setEditId(c.id);setEditName(c.name);}} className="text-blue-600">Edit</button>
                {c.active!==false?<button onClick={()=>deact(c.id)} className="text-red-600">Off</button>:<button onClick={()=>react(c.id)} className="text-green-600">On</button>}
              </div>
            </>
          )}
        </div>
      ))}
      <div className="flex gap-2">
        <input value={newName} onChange={e=>setNewName(e.target.value)} placeholder="New category" className="flex-1 px-2 py-1 border rounded text-sm"/>
        <button onClick={add} className="bg-blue-600 text-white px-3 py-1 rounded text-sm">Add</button>
      </div>
    </div>
  );
};

export default CategoryManager;
